import React from 'react';
import { ChevronDown } from 'lucide-react';
import { NavItem } from './NavItem';

export function NavSection({
  category,
  items,
  collapsed,
  onToggleCollapse,
  isFavorite,
  onToggleFavorite,
  variant,
  headerIcon,
  showStarsOnItems = true,
  unreadCounts,
}) {
  const sectionClass = [
    'kp-nav-section',
    collapsed ? 'kp-nav-section--collapsed' : '',
    variant ? `kp-nav-section--${variant}` : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={sectionClass}>
      <button
        type="button"
        className="kp-nav-section-header"
        onClick={onToggleCollapse}
        aria-expanded={!collapsed}
      >
        <span className="kp-nav-section-header-label">
          {headerIcon ? <span className="kp-nav-section-icon">{headerIcon}</span> : null}
          {category.label}
        </span>
        <ChevronDown className="kp-nav-section-chevron" size={12} strokeWidth={2.5} aria-hidden="true" />
      </button>
      <div className="kp-nav-items">
        {items.map((module) => (
          <NavItem
            key={`${module.to}::${module.label}`}
            module={module}
            isFavorite={isFavorite ? isFavorite(module.label) : false}
            onToggleFavorite={onToggleFavorite}
            showStar={showStarsOnItems && !!onToggleFavorite}
            unreadCount={unreadCounts ? unreadCounts[module.label] || 0 : 0}
          />
        ))}
      </div>
    </div>
  );
}
